import { createAction } from '@reduxjs/toolkit';

export const revertAll = createAction('RESET_STATE');
